import {Component, OnDestroy, OnInit} from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as relatedSelectors from '@app/marketplace/products/state/related-product/related-selectors';
import * as detailsActions from '@app/marketplace/products/state/product-details/details-actions';
import * as relatedActions from '@app/marketplace/products/state/related-product/related-actions';
import { Utils } from '@app/marketplace/core/helpers/utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-related-products',
  templateUrl: './related-products.component.html',
  styleUrls: ['./related-products.component.css']
})

export class RelatedProductsComponent implements OnInit, OnDestroy
{
  data$ :Observable<any>;
  isLoading$: Observable<boolean>;
  count$: Observable<number>;
  theme = { 'min-width': '200px', 'min-height': '219px', background: '#f1f1f1' };
  constructor(
    private store: Store<any>,
    private router: Router) {
     this.data$ = of([]);
     this.isLoading$ = this.store.select(relatedSelectors.selectLoading);
     this.data$ = this.store.select(relatedSelectors.selectItems);
  }
  ngOnInit(): void { }
  ngOnDestroy(): void {;}
   public getDetails(product:string,provider:number) {
    window.scroll(0,0);
    if(!product) return;
    let currentUrl = `/market/productos-compras-cuba-online/${Utils.GetProviderName(provider)}/${product}`;
    this.router.navigateByUrl(currentUrl, {skipLocationChange: true}).then(() => {
      this.store.dispatch(detailsActions.LoadingProductDetailAction());
      this.store.dispatch(relatedActions.ResetRelatedProductsAction());
    });
   }
}
